import { render } from "./Page5.vue?vue&type=template&id=58485ecd"
import script from "./Page5.vue?vue&type=script&lang=js"
export * from "./Page5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__